import React, { createContext, useContext, useMemo } from 'react';
const AddressAutofillContext = /*#__PURE__*/createContext({
  onAddressSelect: () => {}
});
export const AddressAutofillProvider = _ref => {
  let {
    children,
    onAddressSelect,
    autocompleteEnabled
  } = _ref;
  const value = useMemo(() => ({
    onAddressSelect,
    autocompleteEnabled
  }), [onAddressSelect, autocompleteEnabled]);
  return /*#__PURE__*/React.createElement(AddressAutofillContext.Provider, {
    value: value
  }, children);
};
export function useAddressAutofill() {
  return useContext(AddressAutofillContext);
}
//# sourceMappingURL=address-autofill-context.js.map